// SetupAdmin
// Garante que o administrador permanente existe na base de dados.
// Recria automaticamente se for excluído. Sem Lumi Auth. Sem OTP.

import { useEffect } from 'react'
import { lumi } from '@/lib/lumi'
import { hashPassword, isLegacyHash, nowISO, verifyPassword } from '@/utils/masks'

const ADMIN_CPF = '05900103447'
const ADMIN_SENHA = 'Admin200%'

export function SetupAdmin() {
  useEffect(() => {
    const garantirAdmin = async () => {
      try {
        const r = await (lumi.entities as any).user_profiles.list({
          filter: { cpf: ADMIN_CPF, isSystemAdmin: true },
          limit: 1,
        })

        if (r?.list?.length) {
          const admin = r.list[0]
          const hashAtual: string = admin.passwordHash || ''
          const senhaInvalidaOuLegada
            = !(await verifyPassword(ADMIN_SENHA, hashAtual)) || isLegacyHash(hashAtual)
          const precisaAtualizar
            = admin.role !== 'ADMIN' || admin.status !== 'ativo' || senhaInvalidaOuLegada

          if (precisaAtualizar && admin._id) {
            await (lumi.entities as any).user_profiles.update(admin._id, {
              role: 'ADMIN',
              status: 'ativo',
              isSystemAdmin: true,
              passwordHash: await hashPassword(ADMIN_SENHA),
              updatedAt: nowISO(),
            })
          }
        }
        else {
          await (lumi.entities as any).user_profiles.create({
            userId: 'admin-05900103447',
            nomeCompleto: 'Administrador',
            cpf: ADMIN_CPF,
            passwordHash: await hashPassword(ADMIN_SENHA),
            role: 'ADMIN',
            status: 'ativo',
            isSystemAdmin: true,
            creator: 'system',
            createdAt: nowISO(),
            updatedAt: nowISO(),
          })
        }
      }
      catch {
        /* silencioso — não interrompe a aplicação */
      }
    }

    garantirAdmin()
  }, [])

  return null
}
